
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { BillingService } from '../billing.service';

@Component({
    selector: 'fleet-billing-banner',
    imports: [],
    template: `@if (billingService.showBillingIssues()) {
  <div
    class="bg-warn-600"
    >
    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between flex-wrap">
        <div class="w-0 flex-1 flex items-center">
          <span class="flex p-2 rounded-lg bg-warn-800">
            <!-- Heroicon name: outline/exclamation-triangle -->
            <svg
              class="h-6 w-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              aria-hidden="true"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
            </svg>
          </span>
          <p class="ml-3 font-medium text-white">
            <span>
              {{ billingService.billingMessage() }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
}`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class BillingBannerComponent {
  constructor(public billingService: BillingService) {}
}
